import { render, staticRenderFns } from "./by_channelPacket.vue?vue&type=template&id=1ecc5b2c&scoped=true"
import script from "./by_channelPacket.vue?vue&type=script&lang=js"
export * from "./by_channelPacket.vue?vue&type=script&lang=js"
import style0 from "./by_channelPacket.vue?vue&type=style&index=0&id=1ecc5b2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecc5b2c",
  null
  
)

export default component.exports